import { forwardRef } from 'react';

import * as S from './Popup.style';
import { IPopupContainerProps, IPopupImgProps } from './Popup.types';

const InformationPopupContainer = forwardRef(
	(
		{ children, closePopup }: IPopupContainerProps,
		ref: React.ComponentPropsWithRef<React.ElementType>['ref'],
	) => (
		<S.Container
			onClick={(e) => {
				e.stopPropagation();
				e.preventDefault();
				closePopup();
			}}
		>
			<S.Wrapper
				onClick={(e) => {
					e.stopPropagation();
					e.preventDefault();
				}}
				ref={ref}
			>
				{children}
			</S.Wrapper>
		</S.Container>
	),
);
InformationPopupContainer.displayName = 'InformationPopupContainer';

const SingleInputFormPopupContainer = forwardRef(
	(
		{ children, closePopup }: IPopupContainerProps,
		ref: React.ComponentPropsWithRef<React.ElementType>['ref'],
	) => (
		<S.Container
			onClick={(e) => {
				e.stopPropagation();
				e.preventDefault();
				closePopup();
			}}
		>
			<S.SingleInputFormPopupWrapper
				onClick={(e) => {
					e.stopPropagation();
					e.preventDefault();
				}}
				ref={ref}
			>
				{children}
			</S.SingleInputFormPopupWrapper>
		</S.Container>
	),
);
SingleInputFormPopupContainer.displayName = 'SingleInputFormPopupContainer';

const PromotionPopupImg = forwardRef(
	(
		{ src, alt, onClick }: IPopupImgProps,
		ref: React.ComponentPropsWithRef<React.ElementType>['ref'],
	) => <S.Img ref={ref} src={src} alt={alt} onClick={onClick} />,
);
PromotionPopupImg.displayName = 'PromotionPopupImg';

export { InformationPopupContainer, PromotionPopupImg, SingleInputFormPopupContainer };
